<template>
  <Layout>
    <DefaultHeader slot="header" />

    <div class="text-center mt-16">
      <h1>
        Page Not Found
      </h1>

      <h4 class="mb-10 font-light">
        The page you're looking for is missing.
      </h4>

      <button
        type="button"
        class="btn btn-secondary btn-large"
        @click="$router.back()"
      >
        <ArrowLeft class="btn-icon-left" />

        Go Back
      </button>
    </div>
  </Layout>
</template>

<script>
import ArrowLeft from '@/assets/svg/icons/arrow-left.svg?inline'
import DefaultHeader from '@/components/DefaultHeader'

import Layout from '@/components/Layout'

export default {
  layout: 'simple',

  components: { DefaultHeader, ArrowLeft, Layout },

  props: {
    error: { type: Object, required: true },
  },
}
</script>
